import { Routes, Route, Navigate } from 'react-router-dom';
import { DataHome } from './Datas.Home';
import { DataBus, DataFleet } from '.';


export { DataLayout };

function DataLayout() {

    return (
        <div className="pt-12">
            <Routes>
                <Route index element={<DataHome />} />
                <Route path="bus/:busVin" element={<DataBus />} />
                <Route path="flotte/:flotteId" element={<DataFleet />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </div>
    );
}
